export const faqsConstant = 
{
    GET_FAQS_REQUEST: "GET_FAQS_REQUEST",
    GET_FAQS_SUCCESS: "GET_FAQS_SUCCESS",
    GET_FAQS_FAILURE: "GET_FAQS_FAILURE",
}